import { render } from "./IncidencesConfigurationComponent.vue?vue&type=template&id=48155e10"
import script from "./IncidencesConfigurationComponent.vue?vue&type=script&lang=js"
export * from "./IncidencesConfigurationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__